import BaseRate from 'rc-rate'
import cx from 'classnames'
import { CSSProperties } from 'react'
import { Text, FormError } from '@/components/ui'
import { IScale } from '@/models'
import { RateTitle } from '../rate-title/rateTitle'

interface IRateProps {
  classNameWrapper?: string
  view?: 'title' | 'star'
  name?: string
  count: number
  value?: number | undefined
  defaultValue?: number
  onChange?: (value: number) => void
  label?: string
  character?: any
  allowClear?: boolean
  allowHalf?: boolean
  disabled?: boolean
  question?: IScale
  style?: CSSProperties
  errors?: any
  prefixcls?: string
}

const Rate = ({
  classNameWrapper,
  view = 'star',
  name,
  count,
  value,
  defaultValue,
  onChange,
  label = 'Ваша оценка:',
  character,
  allowClear = false,
  allowHalf,
  disabled = false,
  question,
  style,
  errors,
  prefixcls
}: IRateProps) => (
  <div className={cx('rate', classNameWrapper)}>
    <div>
      <Text as='p' size='sm' className='rate__your-rate'>
        {label}
      </Text>
      {view === 'star' && (
        <BaseRate
          count={count}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          character={character}
          allowClear={allowClear}
          allowHalf={allowHalf}
          disabled={disabled}
          style={style}
        />
      )}
      {view === 'title' && <RateTitle value={value} question={question} onChange={onChange} prefixcls={prefixcls} />}
    </div>
    {name && <FormError message={errors?.[name]?.message} />}
  </div>
)

export default Rate
